export enum Status {
  ACTIVE = 'Aktiv',
  INACTIVE = 'Inaktiv',
  PASSWORD_IDLE = "Nie angemeldet",
  REGISTERING = "Registrierend"
}
